import { ComponentProps } from 'react';
import { Control, Controller, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type SelectControlledOption = {
    label: string;
    value: string;
    disabled?: boolean;
};

type SSelectProps = ComponentProps<'s-select'>;

type SelectControlledProps<T> = Omit<SSelectProps, 'name' | 'value' | 'onChange' | 'onInput' | 'error' | 'children'> & {
    control: Control<T>;
    name: Path<T>;
    options: SelectControlledOption[];
};

export default function SelectControlled<T>({ control, name, label, options, ...props }: SelectControlledProps<T>) {
    const { t } = useTranslation();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { value, onBlur, onChange }, fieldState: { error } }) => (
                <s-select
                    {...props}
                    label={label}
                    name={name}
                    value={value?.toString() ?? ''}
                    error={error?.message ? t(error.message as never) : undefined}
                    onChange={(event) => onChange(event.currentTarget.value)}
                    onBlur={onBlur}
                >
                    {options.map((option) => (
                        <s-option key={option.value} value={option.value} disabled={option.disabled}>
                            {option.label}
                        </s-option>
                    ))}
                </s-select>
            )}
        />
    );
}
